// @flow
import React from 'react'

import AuthStatusMobile from './AuthStatusMobile'
import AuthStatusDesktop from './AuthStatusDesktop'

type Props = {
  color: string,
  isAuthenticated: boolean,
  width: string
}

const AuthStatusToggle = (props: Props) => (
  props.width === 'xs'
    ? <AuthStatusMobile color={props.color} />
    : <AuthStatusDesktop isAuthenticated={props.isAuthenticated} color={props.color} />

)

export default AuthStatusToggle
